<template>
  <div
    class="capsule-layer-container"
    data-v-step="1"
    :data-layer-id="layer.id"
  >
    <div
      data-v-step="2"
      :data-layer-id="layer.id"
      class="capsule-layer-container-inner"
    >
      <b-button
        v-if="showHideBtn"
        class="btn-hide-layer float-right circle"
        v-bind:class="{
          hidden: hidden,
          'hovering-slide': hidden && hovering,
        }"
        variant="link"
        size="sm"
        @click="toggleLayerVisibility()"
        @mouseenter="setHoverHideBtn(true)"
        @mouseleave="setHoverHideBtn(false)"
      ></b-button>
      <div
        :id="refName"
        class="swiper-outer-wrapper"
        v-bind:class="{
          'hidden-item': hidden,
          'hovering-hide-btn': hoveringHideBtn,
          'show-capsule-page': onShowCapsulePage,
        }"
      >
        <swiper
          v-if="swiperOptions"
          :ref="refName"
          :options="swiperOptions"
          @slideChange="onSlideChange"
          watch-slides-visibility
          @mouseenter.native="setHoverSlide(true)"
          @mouseleave.native="setHoverSlide(false)"
          @clickSlide="handleSwiperSlideClick"
        >
          <swiper-slide
            v-for="(product, index) in sortedProducts"
            :key="product.id"
            :data-product-id="product.id"
            :data-product-index="index"
          >
            <div class="layer-content-wrapper">
              <div class="layer-image-wrapper">
                <b-img
                  :src="product.featured_image"
                  class="img-fluid w-100 d-block layer-image"
                />
              </div>
              <div class="brand align-self-center d-block">
                <span class="text text-truncate-fade">
                  {{ product.brand_name }}
                </span>
              </div>
              <div class="slider-footer-placeholder"></div>
            </div>
          </swiper-slide>
          <div
            class="swiper-pagination"
            slot="pagination"
            v-if="hasMultipleProducts"
            v-show="!hidden"
          ></div>
          <div
            class="swiper-button-prev"
            slot="button-prev"
            v-bind:class="{ 'swiper-button-hidden': !hovering }"
            v-if="hasMultipleProducts"
            v-show="!hidden"
          ></div>
          <div
            class="swiper-button-next"
            slot="button-next"
            v-bind:class="{ 'swiper-button-hidden': !hovering }"
            v-if="hasMultipleProducts"
            v-show="!hidden"
          ></div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import CapsuleUtils from "@/utils/CapsuleUtils";
import MiscUtils from "@/utils/MiscUtils";
import { bus } from "@/main";

export default {
  props: {
    layer: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      featureTourTriggerredSwipe: false,
      hidden: false,
      hovering: false,
      hoveringHideBtn: false,
      refName: `mySwiper-${this.layer.id}`,
      swiperOptions: null,
      slideRealIndex: 0,
      sortedProducts: [],
    };
  },

  created() {
    this.detectMobile = MiscUtils.detectMobile;
    this.getGroupName = CapsuleUtils.getGroupName;
  },

  mounted() {
    if (this.layer) {
      this.swiperOptions = {
        initialSlide: 0,
        slidesPerView: 1,
        centeredSlides: true,
        loop: this.hasMultipleProducts,
        grabCursor: false,
        speed: 450,
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: false,
          clickable: true,
        },
        navigation: {
          hiddenClass: "swiper-button-hidden",
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      };

      this.initializeSortedProducts();
      this.initializeHoveringHideBtn();

      bus.$on("featureTourTriggerNextSlide", (layerId) => {
        if (this.layer.id === layerId) {
          this.featureTourTriggerredSwipe = true;
          this.swiper.slideNext();
        }
      });

      this.$nextTick(() => this.goToUrlProducts(this.$route.query));
    }
  },

  methods: {
    goToProduct(productId) {
      if (this.hidden) this.hidden = false;

      if (productId !== this.activeProduct["id"]) {
        const index = this.findProductIndex(productId);
        this.goToSlide(index);
      }
    },

    findProductIndex(productId) {
      return this.sortedProducts.findIndex((p) => p.id === productId);
    },

    initializeSortedProducts() {
      if (this.layer.layer_products_count > 0) {
        this.sortedProducts = this.layer.products.sort(
          (a, b) => a.sequence - b.sequence
        );
      }
    },

    initializeHoveringHideBtn() {
      this.hoveringHideBtn = this.detectMobile();
    },

    handleSwiperSlideClick(index, realIndex) {
      let i = this.hasMultipleProducts ? realIndex : index;
      let product = this.sortedProducts[i];

      this.hidden
        ? this.toggleLayerVisibility()
        : this.openProductModal(product);

      bus.$emit("featureTourOpenProductModal");
    },

    goToSlide(index) {
      this.swiper.slideToLoop(index);
    },

    toggleLayerVisibility() {
      this.hidden = !this.hidden;

      this.emitActiveProductId();
    },

    onSlideChange() {
      if (!this.featureTourTriggerredSwipe) {
        bus.$emit("featureTourSwipingCapsule", this.layer);
      }
      this.slideRealIndex = this.swiper.realIndex;
      this.emitActiveProductId();
    },

    openProductModal(product) {
      bus.$emit(
        "openModal",
        product,
        this.getGroupName(this.layer.display_name),
        this.refName
      );
    },

    emitActiveProductId() {
      if (!this.onShowCapsulePage) return;

      const payload = {
        layerSlug: this.layer.slug,
        productId: this.hidden ? null : this.activeProduct["id"],
      };

      bus.$emit("emitActiveProductId", payload);
    },

    setHoverSlide(value) {
      this.hovering = value;
    },

    setHoverHideBtn(value) {
      this.hoveringHideBtn = this.detectMobile() ? true : value;
    },

    goToUrlProducts(queryParams) {
      if (this.onShowCapsulePage && this.layer.layer_products_count > 0) {
        if (Object.keys(queryParams).length > 0) {
          queryParams.hasOwnProperty(this.layer.slug)
            ? this.goToProduct(parseInt(queryParams[this.layer.slug]))
            : (this.hidden = true);
        }
      }
    },
  },

  computed: {
    hasMultipleProducts() {
      return this.layer.layer_products_count > 1;
    },

    swiper() {
      return this.$refs[this.refName].$swiper;
    },

    activeProduct() {
      return this.sortedProducts[this.slideRealIndex];
    },

    showHideBtn() {
      return this.onShowCapsulePage && (this.hovering || this.hoveringHideBtn);
    },

    onShowCapsulePage() {
      return this.$router.currentRoute.name === "ShowCapsule";
    },

    queryParams() {
      return this.$route.query;
    },
  },

  watch: {
    queryParams: function (newVal, oldVal) {
      this.$nextTick(() => this.goToUrlProducts(newVal));
    },

    hidden: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.swiper.allowClick = !newVal;
        this.swiper.allowTouchMove = !newVal;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

.capsule-layer-container {
  cursor: pointer;
  border-top: 1px solid #ffffff;
  border-radius: 0.3em !important;
  height: 100%;

  .capsule-layer-container-inner {
    height: 100%;
  }
}

// Swiper main
// --------------------------------------------
.swiper-outer-wrapper {
  background-color: #fff;
  border-top: 1px solid #ffffff;
  border-radius: 0.3em !important;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  text-align: center;
  height: 100%;

  .swiper-container {
    height: 100%;
  }

  &:not(.hidden-item) {
    &:hover {
      border-top: 1px solid #f2f2f2;
      box-shadow: 0px 5px 5px 0px rgba(169, 169, 169, 1);
    }
  }

  &.hidden-item.hovering-hide-btn .swiper-slide,
  &.hidden-item:hover .swiper-slide {
    filter: blur(3px);
    opacity: 0.6;
  }

  &.hidden-item .swiper-slide {
    filter: blur(3px);
    opacity: 0.4;
    cursor: pointer;
  }
}

// Overrides for ShowCapsule page
.swiper-outer-wrapper.show-capsule-page {
  border-top: 1px solid $grey5;
  border: 1px solid $grey5;

  &:not(.hidden-item) {
    &:hover {
      border-top: 1px solid $grey5;
    }
  }
}

.swiper-button-hidden {
  display: none;
}

.swiper {
  height: auto;

  .swiper-slide {
    line-height: 300px;

    &:nth-child(2n) {
      line-height: 200px;
    }
  }
}

// Navigation buttons
// --------------------------------------------
.swiper-button-prev,
.swiper-button-next {
  background-color: $primary-blue;
  opacity: 0.6;
  content: "";

  &:hover {
    opacity: 1;
  }

  &::after {
    font-size: 22px;
    color: #ffffff;
  }
}

.swiper-button-prev {
  margin-left: -10px;
  // &::after {
  //   content: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAxMjkgMTI5IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxMjkgMTI5IiB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4Ij4KICA8Zz4KICAgIDxwYXRoIGQ9Im04OC42LDEyMS4zYzAuOCwwLjggMS44LDEuMiAyLjksMS4yczIuMS0wLjQgMi45LTEuMmMxLjYtMS42IDEuNi00LjIgMC01LjhsLTUxLTUxIDUxLTUxYzEuNi0xLjYgMS42LTQuMiAwLTUuOHMtNC4yLTEuNi01LjgsMGwtNTQsNTMuOWMtMS42LDEuNi0xLjYsNC4yIDAsNS44bDU0LDUzLjl6IiBmaWxsPSIjRkZGRkZGIi8+CiAgPC9nPgo8L3N2Zz4K");
  // }
}

.swiper-button-next {
  margin-right: -10px;

  // &::after {
  //   content: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAxMjkgMTI5IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxMjkgMTI5IiB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4Ij4KICA8Zz4KICAgIDxwYXRoIGQ9Im00MC40LDEyMS4zYy0wLjgsMC44LTEuOCwxLjItMi45LDEuMnMtMi4xLTAuNC0yLjktMS4yYy0xLjYtMS42LTEuNi00LjIgMC01LjhsNTEtNTEtNTEtNTFjLTEuNi0xLjYtMS42LTQuMiAwLTUuOCAxLjYtMS42IDQuMi0xLjYgNS44LDBsNTMuOSw1My45YzEuNiwxLjYgMS42LDQuMiAwLDUuOGwtNTMuOSw1My45eiIgZmlsbD0iI0ZGRkZGRiIvPgogIDwvZz4KPC9zdmc+Cg==");
  // }
}

// Pagination
// --------------------------------------------
.swiper-pagination /deep/ {
  position: sticky !important;

  .swiper-pagination-bullet {
    margin: -5px 4px !important;
    width: 5px;
    height: 5px;
  }

  .swiper-pagination-bullet-active {
    background-color: $primary-blue !important;
  }
}

// Content
// --------------------------------------------

.for-tailor {
  .layer-image-wrapper {
    padding: 5px;

    .layer-image {
      max-height: 114px !important;
    }
  }
}

.layer-content-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  .slider-footer-placeholder {
    height: 15px;
    width: 100%;
  }

  .layer-image-wrapper {
    padding: 5px;
    height: auto;

    .layer-image {
      height: auto;
      max-height: 114px;
      object-fit: contain;
    }

    @include for-sm-phone-only {
      padding: 5px;

      .layer-image {
        max-height: 89px;
      }
    }

    @include for-tablet-portait-only {
      padding: 10px;

      .layer-image {
        max-height: 111px;
      }
    }

    @include for-tablet-portrait-up {
      padding: 5px;

      .layer-image {
        max-height: 110px;
      }
    }

    @include for-tablet-landscape-up {
      padding: 8px;

      .layer-image {
        max-height: 150px;
      }
    }

    @include for-desktop-up {
      padding: 10px;

      .layer-image {
        height: 194px;
        max-height: 194px;
      }
    }
  }
}

.tailor-container {
  .layer-content-wrapper {
    .layer-image-wrapper {
      @include for-desktop-up {
        padding: 10px;

        .layer-image {
          height: 150px;
          max-height: 150px;
        }
      }
    }
  }
}

// -----------------------
// CUSTOMIZATION
//
// Style for: showCapsule
// -----------------------
.show-capsule-container {
  .layer-content-wrapper {
    .layer-image-wrapper {
      padding: 5px;

      .layer-image {
        max-height: 105px;
      }

      @include for-tablet-portrait-up {
        padding: 8px;

        .layer-image {
          max-height: 160px;
        }
      }

      @include for-tablet-landscape-up {
        padding: 10px;

        .layer-image {
          max-height: 200px;
        }
      }

      @include for-desktop-up {
        padding: 10px;

        .layer-image {
          height: 250px;
          max-height: 250px;
        }
      }
    }
  }
}

// Content text
// --------------------------------------------
.layer-content-wrapper {
  .brand {
    color: $primary-blue;
    font-size: 14px;
    line-height: 1.2;
    color: $grey3;
    font-weight: 100;
    padding-left: 10px;
    padding-right: 10px;
    overflow: hidden;
    margin-top: -2px;
    max-width: 100%;

    /* same color as text */
    background: linear-gradient(
      to right,
      $grey2 80%,
      rgba(160, 164, 168, 0) 100%
    );
    background-clip: border-box;
    -webkit-background-clip: text;
    -webkit-text-fill-color: #fff0;

    /* overwrite the bootstrap shadow  */
    text-shadow: 0 -1px 0 rgba(255, 255, 255, 0.2);
  }

  .text-truncate-fade {
    white-space: nowrap;
    width: 100%;
  }
}

.btn-hide-layer {
  position: absolute;
  z-index: 2;
  top: -5px;
  right: -5px;
  background: #fff;
  border: 1px solid lighten($primary-blue, 60%);
  color: $primary-blue;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  text-decoration: none;
  transition: all 0.23s ease-in-out;

  @include for-tablet-portrait-up {
    border: 1px solid $primary-blue;
    top: -2px;
    width: 35px;
    height: 35px;
    box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14),
      0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.2);
  }

  &:before {
    content: "×";
    line-height: 8px;
    font-size: 20px;
    font-weight: 300;
    margin-left: -1px;

    @include for-tablet-portrait-up {
      line-height: 13px;
      font-size: 24px;
      margin-left: 0;
    }
  }

  &.hidden {
    transform: rotate(45deg);
  }

  // &:active {
  //   box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14),
  //     0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.2);
  // }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      color: $primary-accent;
    }
  }

  &:focus {
    box-shadow: none;
  }
}

.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.4);
}
</style>



// WEBPACK FOOTER //
// src/components/capsule/CapsuleLayer.vue